import { Inject, Injectable } from '@angular/core';
import { map, tap, withLatestFrom } from 'rxjs/operators';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { loadUserInformation, loadUserInformationSuccess, resetUserInformation } from './actions';
import { UserInformation } from './user-information';
import { CookieService } from 'ngx-cookie-service';
import {
  ACCOUNT_NUMBER,
  COOKIES_PAGE_USER_NAME,
  PHONE_NUMBER,
  SELECTED_SUBSCRIBER_NUMBER,
} from '@rci/self-serve-fido/app.constant';
import { LOCAL_STORAGE } from '@rci/storage/local-storage.service';
import { fetchAccountListSuccess } from '@rogers/self-serve-common/account';
import { UserInformationStateFacade } from '@rci/self-serve-fido/state/user-information/user-information-state.facade';

@Injectable()
export class UserInformationEffects {
  loadUserInformation$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadUserInformation),
      map(_ => {
        const userInfo: UserInformation = {};

        const selectedAccountNumber = this.localStorage.getItem(ACCOUNT_NUMBER);
        if (selectedAccountNumber) {
          userInfo.selectedAccountNumber = selectedAccountNumber;
        }
        const selectedSubscriberNo =
          this.localStorage.getItem(PHONE_NUMBER) || this.localStorage.getItem(SELECTED_SUBSCRIBER_NUMBER);

        if (selectedSubscriberNo) {
          userInfo.selectedSubscriberNo = selectedSubscriberNo;
        }
        return loadUserInformationSuccess({ userInfo });
      }),
    ),
  );

  resetUserInformation$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(resetUserInformation),
        tap(_ => this.cookieService.delete(COOKIES_PAGE_USER_NAME)),
      ),
    { dispatch: false },
  );

  setSelectedAccountNumber$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fetchAccountListSuccess),
        withLatestFrom(this.userInformationStateFacade.getSelectedAccountNumber()),
        tap(([{ accounts }, selectedAccountNumber]) => {
          if (
            (selectedAccountNumber &&
              !!accounts &&
              accounts.length > 0 &&
              accounts.some(account => account.accountNumber === selectedAccountNumber)) ||
            !accounts ||
            accounts.length === 0
          ) {
            return;
          }

          this.userInformationStateFacade.updateSelectedAccountNumber(accounts[0].accountNumber);
        }),
      ),
    { dispatch: false },
  );

  constructor(
    @Inject(LOCAL_STORAGE) private readonly localStorage: Storage,
    private readonly actions$: Actions,
    private readonly cookieService: CookieService,
    private readonly userInformationStateFacade: UserInformationStateFacade,
  ) {}
}
